import ProductsList from './products-list';

export default class ProductsListMobile extends ProductsList {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
    }

    _retrieveDOM() {

        this.dom.popin = this.dom.page.querySelector('.js-popin');
        this.dom.btnPopin = this.dom.page.querySelector('.js-btn-popin');
        this.dom.btnClosePopin = this.dom.page.querySelector('.js-close-popin');
        this.dom.dropdown = [].slice.call(this.dom.page.querySelectorAll('.js-dropdown-0'));
        this.dom.menu = document.body.querySelector('.ct.ct--menu');

        console.log( this.dom.dropdown);
    }

    bind() {
        super.bind();

        this.dom.btnPopin.addEventListener('click' , this.openPopin.bind(this))
        this.dom.btnClosePopin.addEventListener('click' , this.closePopin.bind(this))

        for (let i = 0; i < this.dom.dropdown.length; i++) {
            let arrow = this.dom.dropdown[i].querySelector('.icon');
            arrow.addEventListener('click' , () => {
                if( this.dom.dropdown[i].classList.contains('active') ) {
                    this.dom.dropdown[i].classList.remove('active')
                } else {
                    this.dom.dropdown[i].classList.add('active')
                }
            });
        }
    }

    openPopin() {
        if ( !this.dom.popin.classList.contains('show') ) {

            this.dom.popin.classList.add('show')
            document.body.classList.add('no-scroll')
            this.dom.menu.classList.add('hide');

        };
    }

    closePopin() {
        if( this.dom.popin.classList.contains('show') ) {

            this.dom.popin.classList.remove('show')
            document.body.classList.remove('no-scroll')
            this.dom.menu.classList.remove('hide');

        };
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/products/list/products-list.mobile.js